export default __webpack_public_path__ + "static/media/bh1.3011706d.webp";